<template>
  <Layout>
    <div class="row">
      <div>
        <div class="card" style="margin-bottom:0px">
          <div class="">
            <el-tabs v-model="currentType" type="card">
              <!-- 文章列表 -->
              <el-tab-pane label="文章列表" name="article">
                <list v-if="currentType == 'article'"></list>
              </el-tab-pane>
              <!-- 文章列表 -->

              <!-- 初编池 -->
              <!-- <el-tab-pane label="初编池" name="first">
                <first v-if="currentType == 'first'"></first>
              </el-tab-pane> -->
              <!-- 初编池 -->

              <!-- 草稿 -->
              <el-tab-pane label="草稿" name="draft">
                <draft v-if="currentType == 'draft'"></draft>
              </el-tab-pane>
              <!-- 草稿 -->
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import list from "./list"; //文章列表
import first from "./first"; //初编池
import draft from "./draft"; //草稿列表
import { addCache, updateCache } from "@/util/localAche.js";
/**
 * Tabs & accordions component
 */
export default {
  components: {
    Layout,
    list,
    first,
    draft,
  },
  data() {
    return {
      title: "homeRecommend",
      currentType: "",
      text: `
         Raw denim you probably haven't heard of them jean shorts Austin. Nesciunt tofu stumptown aliqua, retro synth master cleanse. Mustache cliche tempor, williamsburg carles vegan helvetica. Reprehenderit butcher retro keffiyeh dreamcatcher synth. Cosby sweater eu banh mi, qui irure terry richardson ex squid. Aliquip placeat salvia cillum iphone. Seitan aliquip quis cardigan american apparel, butcher voluptate nisi qui.
        `,
      content: `Food truck fixie locavore, accusamus mcsweeney's marfa nulla single-origin coffee squid. Exercitation +1 labore velit, blog sartorial PBR leggings next level wes anderson artisan four loko farm-to-table craft beer twee. Qui photo booth letterpress, commodo enim craft beer mlkshk aliquip jean shorts ullamco ad vinyl cillum PBR. Homo nostrud organic, assumenda labore aesthetic magna delectus.`,
    };
  },
  beforeRouteEnter(to, from, next) {
    if (["/articleDetail", "/articleComments"].indexOf(from.path) == -1) {
      console.log("清空文章列表缓存");
      //如果不是从详情或评论页跳转到此页面则清空列表数据
      updateCache("article-list", { list: "" });
      updateCache("article-first", { list: "" });
      updateCache("article-draft", { list: "" });
    }
    if (from && from.path != "/articleDetail") {
      //如果不是从详情回到列表就清空编辑缓存id
      addCache("article-edit", "");
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    if (["/articleDetail", "/articleComments"].indexOf(to.path) == -1) {
      console.log("清空文章列表缓存");
      //如果不是跳转到详情或评论页则清空列表数据
      updateCache("article-list", { list: "" });
      updateCache("article-first", { list: "" });
      updateCache("article-draft", { list: "" });
    }
    next();
  },
  created() {
    if (this.$route.query.type) {
      this.currentType = this.$route.query.type;
    } else {
      this.currentType = "article";
    }
  },

  watch: {
    currentType(newVal, oldVal) {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      query.type = this.currentType;
      this.$router.push({ path: this.$route.path, query });
      // 切换到其它tab时清空本tab缓存的列表数据
      if (oldVal) {
        console.log("oldVal", oldVal);
        this.addCache("article-edit", "");
        if (oldVal == "article") {
          this.updateCache("article-list", { list: "" }, 500);
        } else if (oldVal == "first") {
          this.updateCache("article-first", { list: "" }, 500);
        } else if (oldVal == "draft") {
          this.updateCache("article-draft", { list: "" }, 500);
        }
      }
    },
    $route() {
      if (this.currentType) {
        const query = JSON.parse(JSON.stringify(this.$route.query));
        query.type = this.currentType;
        this.$router.push({ path: this.$route.path, query });
      }
    },
  },
};
</script>
